import { render, staticRenderFns } from "./VerticalArrow.vue?vue&type=template&id=9a953d2a&"
import script from "./VerticalArrow.vue?vue&type=script&lang=js&"
export * from "./VerticalArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports